export class TokenizationError extends Error {
  public constructor() {
    super()

    this.message = 'errors.tokenization'
  }
}
